import { Component, computed, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { NavigationEnd, Router, RouterLink, RouterOutlet } from "@angular/router";
import { filter, map } from "rxjs";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { MatSidenavContainer, MatSidenavModule } from "@angular/material/sidenav";
import { MatMenu } from "@angular/material/menu";
import { MatNavList } from "@angular/material/list";
import { PorscheDesignSystemModule } from "@porsche-design-system/components-angular";

const NAV_ITEMS = [
  { label: "Dashboard", route: "/dashboard" },
  { label: "Architektur", route: "/architecture" }
] as const;

@Component({
  selector: "app-root",
  standalone: true,
  imports: [
    RouterOutlet,
    MatCardModule,
    MatButtonModule,
    MatSidenavContainer,
    MatMenu,
    MatNavList,
    MatSidenavModule,
    RouterLink,
    PorscheDesignSystemModule
  ],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss"
})
export class AppComponent {
  title = "Service Manager";
  readonly navItems = NAV_ITEMS;

  private readonly router = inject(Router);

  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => event.urlAfterRedirects)
    ),
    { initialValue: this.router.url }
  );

  readonly activeTabIndex = computed(() => {
    const index = NAV_ITEMS.findIndex((item) => this.currentUrl().startsWith(item.route));
    return index === -1 ? 0 : index;
  });
}
